import { remoteCartServiceV2 } from '../../services';

export async function syncPendingCartJobHandlerV2() {
    const isOnline = navigator.onLine;

    if (!isOnline) {
        return;
    }

    const cartsToSync = await remoteCartServiceV2.getUnsyncedCarts();

    const syncPromises = cartsToSync.map(async (cart) =>
        remoteCartServiceV2.syncCarts(cart.id),
    );

    await Promise.allSettled(syncPromises);
}
